import Typography from 'typography';

const typography = new Typography({
  baseFontSize: '18px',
  headerFontFamily: ['futura-pt', 'sans-serif'],
  bodyFontFamily: ['Open Sans', 'sans-serif'],
  googleFonts: [
    {
      name: 'Open Sans',
      styles: [
        '300',
        '400',
        '500',
        '600',
        '700',
      ],
    },
  ],
});

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles();
}

export default typography;
export const rhythm = typography.rhythm;
export const scale = typography.scale;
